/* 
 * Lenstore DHTML
 */

/* 
 * TopNav YOOC bar
 */
function showYoocInfo() {
	getObById('yoocInfoBox').style.display = 'block';
}
function hideYoocInfo() {
	getObById('yoocInfoBox').style.display = 'none';
}

/* New product page showwhy blocks - above and below */
function showWhyProd(textbloc, trigger) {
	var marker = getObById(trigger);
	var bloc = getObById(textbloc);
	var posX = marker.offsetLeft;
	var posY = marker.offsetTop;
	bloc.style.display = 'block';
	bloc.style.left = (posX - 247) + 'px';
	bloc.style.top = (posY) + 'px';
}

/* 
 * Content rendered first
 */
var putInLeftNavID = false;
function positionSEODiv(overlayName, holderName, extraOffSetTop, extraOffSetLeft) {
	
}